'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getI18nInstance = undefined;

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var languages = require('./locales/all.json');

var i18nInstance = null;

function getI18nInstance() {
  if (!i18nInstance) {
    i18nInstance = _i18next2.default.createInstance();
    i18nInstance.init({
      fallbackLng: 'en',
      resources: languages,
      ns: ['react-platform-settings'],
      defaultNS: 'react-platform-settings',
      debug: false,
      interpolation: {
        escapeValue: false
      },
      react: {
        wait: true
      }
    });
  }

  return i18nInstance;
}

exports.getI18nInstance = getI18nInstance;